import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import { socketMiddleware } from 'store/reducers-common/Socket/socketMiddleware.ts'

import { errorLogger } from './errorLogger'
import { middlewareApp, middlewareCommon, reducers } from './reducers'

const app = import.meta.env.VITE_APP

const rootReducer = combineReducers({
  ...reducers,
})

export type RootState = ReturnType<typeof rootReducer>

export const store = configureStore({
  devTools: import.meta.env.DEV,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(...middlewareCommon, ...(middlewareApp[app] || []), errorLogger, socketMiddleware()),
  reducer: rootReducer,
})

export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
